import { Button } from '@user-portal/wikr-components';
import styled, { css } from 'styled-components';

import MediaQueries from 'theme/mediaQueries';
import { borderRadius, color } from 'theme/selectors';

export const ModalContent = styled.div`
    height: 100%;
    padding: 83px 8px 32px;
    overflow: hidden;
    background: ${color('surface-main')};

    ${MediaQueries.largeTablet} {
        padding: 83px 16px 32px;
    }
`;

export const ModalHeaderTitle = styled.div`
    position: fixed;
    display: flex;
    justify-content: space-between;
    text-align: center;
    align-items: center;
    padding: 16px;
    background: ${color('surface-main')};
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
    border-bottom: 1px solid ${color('border-default')};

    ${MediaQueries.laptop} {
        padding: 16px 40px;
    }
`;

export const TitleText = styled.div`
    flex: 1;
`;

export const Image = styled.img`
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const IconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${color('surface-secondary')};
    height: 44px;
    width: 44px;
    border-radius: 50%;

    &:hover {
        cursor: pointer;
    }
`;

export const SetReminderButton = styled(Button)`
    margin-top: 24px;
    width: 100%;
`;

export const SmallButton = styled(Button)`
    padding: 10px 16px;
    min-height: 40px;
    min-width: unset;
    width: auto;
    text-transform: uppercase;

    * {
        font-size: 14px;
        line-height: 16px;
    }
`;

export const CardItem = styled.div<{ small?: boolean }>`
    position: relative;
    min-height: 320px;
    width: 100%;
    padding: 16px;
    margin-bottom: 24px;
    display: flex;
    align-items: flex-end;
    border: 2px solid ${color('border-default')};
    border-radius: ${borderRadius('small')};
    overflow: hidden;

    ${({ small }) =>
        small &&
        css`
            border-width: 1px;
            min-height: auto;
        `}
`;

export const CardImageWrapper = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 2;

    &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
            180deg,
            rgba(54, 55, 58, 0) 22%,
            rgba(18, 19, 20, 0.576) 54.15%,
            rgba(0, 0, 0, 0.72) 88.61%
        );
    }
`;

export const TextWrapper = styled.div`
    position: relative;
    z-index: 3;
`;
